var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsersFill = function SvgUsersFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#users-fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff5c7f"
    },
    d: "M24 11.994C24 5.363 18.633 0 12.003 0 5.367 0 0 5.362 0 11.994c0 7.25 6.386 12.65 13.023 11.944C19.153 23.424 24 18.294 24 11.993ZM12.003 1.875c6.974 0 11.797 6.844 9.595 13.363a6.422 6.422 0 0 0-2.208-1.72c2.095-2.368.42-6.15-2.777-6.15-3.19 0-4.873 3.776-2.77 6.15a6.442 6.442 0 0 0-2.71 2.407 6.73 6.73 0 0 0-.963-.569c2.108-2.375.407-6.15-2.77-6.15-3.19 0-4.873 3.775-2.771 6.15a6.351 6.351 0 0 0-1.683 1.156C-.388 9.87 4.416 1.875 12.003 1.875Z",
    fill: "#FF5C7F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "users-fill_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h23.981v24H0z"
  })))));
};
export default SvgUsersFill;